import PropTypes from "prop-types";
import React from "react";

import PageBody from "@components/PageBody";
import Report from "@components/Report";
import settings from "@settings/index";
import AdminPageTemplate from "@templates/AdminPage";

function ReceivedMessage(props) {
  return (
    <AdminPageTemplate breadcrumbs={props.breadcrumbs}>
      <PageBody title="Mensagens Recebidas">
        <Report quickSightID={settings.reports.RECEIVED_MESSAGES} />
      </PageBody>
    </AdminPageTemplate>
  );
}

ReceivedMessage.propTypes = {
  breadcrumbs: PropTypes.array,
};

ReceivedMessage.defaultProps = {
  breadcrumbs: [],
};

export default ReceivedMessage;
